import * as React from 'react';
import { Row, Col } from 'antd';
import { observer } from 'mobx-react';
import { Prompt } from 'react-router';

import { BooleanView } from 'src/core/ui/boolean.view';
import { TabLanguageController } from 'src/core/ui/language/tab-language.controller';
import { PolicyRuleDataService } from 'src/app/bookings/policy-rules/policy-rule-form.data';
import { GenericPolicyFormView } from 'src/app/bookings/policies/generic-policy-form.view';
import { ContextService } from 'src/core/services/context.service';
import { VisibilityEditorView } from 'src/app/shared/parts/visibility-editor.view';

interface Props extends ComponentViewProps<QuoteProductVisibilityPolicyItem> {
	title: string,
	save: () => Promise<void>;
	cancel: () => void;
	mode: ControlMode;
	onModeChange: (mode: ControlMode) => void;
	policyRuleDataService: PolicyRuleDataService;
	breadcrumb: any[];
	goToCard: (text: any, key: string, model: PolicyRuleItem) => void;
	contextService: ContextService;
}

@observer
export class QuoteProductVisibilityPolicyFormView extends React.Component<Props, {}> {
	public render(): React.ReactNode {
		const { model, mode, setBusy, contextService } = this.props;
		const translations = (model as any).dynamicProperties['displayName'];
		const array: TabLanguageModel[] = [
			{
				title: 'Name',
				dynamicProperties: translations,
				rows: 2
			}
		];

		return (
			<React.Fragment>
				<Prompt
					when={contextService.isDirty}
					message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
				/>
				<GenericPolicyFormView
					rulesSections={['general', 'product']}
					policyRuleOwner={{
						quoteProductVisibilityPolicyId: model.id,
						quoteProductVisibilityPolicy: model
					}}
					{...this.props}
				>
					<Row>
						<Col xs={24}>
							<TabLanguageController
								model={model}
								dynamicProperties={array}
								mode={mode}
								setBusy={setBusy}
								isRichTextBox={false}
							/>
						</Col>
						<Col xs={12}>
							<VisibilityEditorView
								disabled={this.props.mode == 'display'}
								label="Visibility"
								model={model.dynamicProperties.visibility}
							/>
						</Col>
						<Col xs={12}>
							<BooleanView
								label="Active"
								value={model.isActive}
								onChanged={(newVal) => {
									model.isActive = newVal;
								}}
								mode={this.props.mode}
							/>
						</Col>
					</Row>
				</GenericPolicyFormView>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-product-visibility-policies/form/quote-product-visibility-policy-form.view.tsx